// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"12":"profiler","777":"recorder"}[chunkId] + "." + {"12":"5e96f16481646640","777":"ea904db76dd12592"}[chunkId] + ".js";
};